export default [{
    name: 'Квартира',
    genitiveName: 'Квартиры',
    key: 'flat',
}, {
    name: 'Комната',
    genitiveName: 'Комнаты',
    key: 'room',
}, {
    name: 'Дом',
    genitiveName: 'Дома',
    key: 'house',
}, {
    name: 'Койко-место',
    genitiveName: 'Койко-места',
    key: 'bed',
}];
